import { DEFAULT_LANGUAGE } from '@cibli/shared';

export const getCountryCode = (language?: string) => {
  if (!language) {
    if (DEFAULT_LANGUAGE.includes('-')) {
      return DEFAULT_LANGUAGE.split('-')[1].toUpperCase();
    }
    return DEFAULT_LANGUAGE;
  }

  if (language.includes('-')) {
    return language.split('-')[1].toUpperCase();
  }

  return language;
};
